// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"c2bdd80b","149":"6fb784fd","189":"69f3c9d2","397":"60ccf500","424":"b841037b","490":"e26ed671","518":"c8ae5309","667":"8ed9c780","781":"324f3a48"}[chunkId] + ".chunk.js";
};